import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { useModalContext } from '@starbucks-web/pattern-library/lib/components/modal-provider';

import { sharedNotificationMessages } from 'shared/app/messages/notifications';

import { orderingMessages } from '../messages/ordering';
import { TimeSelectionErrorDialog } from '../components/time-selection-error-dialog/time-selection-error-dialog';

import { scheduledTimeSlotLabelSelector } from 'shared/app/state/selectors/ordering';

const useTimeSelectionErrorDialog = () => {
  const { formatMessage } = useIntl();
  const { openModal } = useModalContext();
  const scheduledTimeSlot = useSelector(scheduledTimeSlotLabelSelector);
  const AT_CAPACITY_DIALOG_ID = 'AtCapacityDialogId';
  const TIME_SLOT_RESCHEDULED_DIALOG_ID = 'TimeSlotRescheduledId';
  const UNAVAILABLE_DIALOG_ID = 'UnavailableDialogId';

  const openAtCapacityDialog = () => {
    openModal({
      ariaLabelledBy: AT_CAPACITY_DIALOG_ID,
      component: TimeSelectionErrorDialog,
      componentProps: {
        bodyMessage: formatMessage(orderingMessages.storeAtCapacityDialogBody),
        showChangeStoreButton: true,
        dialogId: AT_CAPACITY_DIALOG_ID,
        headingMessage: formatMessage(
          orderingMessages.storeAtCapacityDialogHeading
        ),
      },
    });
  };
  const openRescheduledDialog = () => {
    openModal({
      ariaLabelledBy: TIME_SLOT_RESCHEDULED_DIALOG_ID,
      component: TimeSelectionErrorDialog,
      componentProps: {
        bodyMessage: formatMessage(
          orderingMessages.timeSlotRescheduledDialogBody
        ),
        dialogId: TIME_SLOT_RESCHEDULED_DIALOG_ID,
        headingMessage: formatMessage(
          orderingMessages.timeSlotRescheduledDialogHeading,
          { scheduledTimeSlot }
        ),
      },
    });
  };
  const openUnavailableDialog = () => {
    openModal({
      ariaLabelledBy: UNAVAILABLE_DIALOG_ID,
      component: TimeSelectionErrorDialog,
      componentProps: {
        bodyMessage: formatMessage(
          sharedNotificationMessages.beBackToNormalSoon
        ),
        dialogId: UNAVAILABLE_DIALOG_ID,
        headingMessage: formatMessage(
          sharedNotificationMessages.somethingWentWrong
        ),
      },
    });
  };

  return {
    openAtCapacityDialog,
    openRescheduledDialog,
    openUnavailableDialog,
    openModal,
  };
};

export default useTimeSelectionErrorDialog;
